import { Avatar, AvatarProps } from "@fluentui/react-components";
import React from "react";

import { getAvatarInitial } from "../../utils/getAvatarInitial";

// 組織アイコンのアップロードは BE 未対応のため、イニシャルを固定カラー背景で表示する
const ORG_AVATAR_COLOR = "#2b2d42";

/** 組織アイコン ({@link AccountPersona} の組織版)。 */
export const OrganizationAvatar: React.FC<{
  name: string;
  size?: AvatarProps["size"];
}> = ({ name, size = 32 }) => {
  const initial = getAvatarInitial(name);
  return (
    <Avatar
      name={name}
      shape="square"
      size={size}
      initials={{
        children: initial,
        style: { backgroundColor: ORG_AVATAR_COLOR, color: "#fff" },
      }}
    />
  );
};
